export const isPxUnits = /^-?\d*px$/;
export const isRemUnits = /^-?\d*[\d.]*rem$/;
export const isEmUnits = /^-?\d*[\d.]*em$/;
export const isPercentUnits = /^-?\d*[\d.]*%$/;
export const isViewHeightUnits = /^-?\d*[\d.]*vh$/;
export const isViewWidthUnits = /^-?\d*[\d.]*vw$/;
